import BaseUIContactView from 'xui/modules/contact/BaseUIContactView'

class ContactView extends BaseUIContactView {
  static displayName = 'ContactView'
}

export default ContactView
